import { render, staticRenderFns } from "./UpcomingAuctions.vue?vue&type=template&id=01cc1e2b&scoped=true&"
import script from "./UpcomingAuctions.vue?vue&type=script&lang=js&"
export * from "./UpcomingAuctions.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingAuctions.vue?vue&type=style&index=0&id=01cc1e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc1e2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
